import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { authService } from '../services';

function Navbar() {
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const isAuthenticated = authService.isAuthenticated();
  const user = authService.getCurrentUser();

  const handleLogout = () => {
    authService.logout();
    navigate('/login');
    setIsMenuOpen(false);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-header">
          <Link to="/" className="navbar-brand" onClick={closeMenu}>
            <img src="/annapiggy-logo.png" alt="Anna Piggy Logo" className="navbar-logo" />
          </Link>
          
          <div className="menu-icon" onClick={toggleMenu}>
            <div className={isMenuOpen ? 'bar open' : 'bar'}></div>
            <div className={isMenuOpen ? 'bar open' : 'bar'}></div>
            <div className={isMenuOpen ? 'bar open' : 'bar'}></div>
          </div>
        </div>

        <ul className={isMenuOpen ? 'navbar-links active' : 'navbar-links'}>
          <li><Link to="/playlists" onClick={closeMenu}>网页歌单</Link></li>
          <li><Link to="/marshmallows" onClick={closeMenu}>棉花糖</Link></li>
          {isAuthenticated && user && (
            <>
              <li><Link to="/prizes" onClick={closeMenu}>积分兑换</Link></li>
              <li className="user-points">
                ⭐ {user.points} 积分
              </li>
              <li><Link to="/profile" onClick={closeMenu}>个人资料</Link></li>
              <li>
                <button onClick={handleLogout} className="btn btn-outline">
                  退出登录
                </button>
              </li>
            </>
          )}
          {!isAuthenticated && (
            <>
              <li><Link to="/login" onClick={closeMenu}>登录</Link></li>
              <li><Link to="/register" onClick={closeMenu}>注册</Link></li>
            </>
          )}
        </ul>

        {isMenuOpen && (
          <div className="navbar-overlay" onClick={closeMenu}></div>
        )}
      </div>
    </nav>
  );
}

export default Navbar;
